module.exports = __webpack_public_path__ + "static/media/lv_mob_s.f66a096f.png";